<template>
  <div class="app-container">
    <el-card class="mb10">
      <el-form
        ref="queryForm"
        :model="queryForm"
        size="small"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="5">
            <!--车牌号-->
            <el-form-item :label="$t('collectionCenter.licensePlateNumber')">
              <el-input
                v-model="licensePlateNumber"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--MDFE秘钥-->
            <el-form-item :label="$t('mdfeTranslate.MDFEKey')">
              <el-input
                v-model="mdfeKeyStr"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-row :gutter="10">
              <el-col :span="8">
                <!--协议编号-->
                <el-form-item :label="$t('mdfeTranslate.AgreementNumber')">
                  <el-input
                    v-model="queryForm.params.protocolNumber"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--起点-->
                <el-form-item :label="$t('mdfeTranslate.startingPoint')">
                  <el-select
                    v-model="queryForm.params.originState"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    class="formTable"
                    clearable
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="list in senderStateList"
                      :key="list.stateCode"
                      :label="list.stateNameZh + '（' + list.stateNamePu + '）'"
                      :value="list.stateCode"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--目的地-->
                <el-form-item :label="$t('mdfeTranslate.destination')">
                  <el-select
                    v-model="queryForm.params.destinationState"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    class="formTable"
                    clearable
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="list in senderStateList"
                      :key="list.stateCode"
                      :label="list.stateNameZh + '（' + list.stateNamePu + '）'"
                      :value="list.stateCode"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="" class="numberSearch">
                  <template slot="label">
                    <el-select v-model="queryForm.params.timeType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                      <!--  创建时间 -->
                      <el-option :label="$t('GlobalSetObj.CreationTime')" :value="1" />
                      <!-- 关闭时间 -->
                      <el-option :label="$t('GlobalSetObj.ClosingTime')" :value="2" />
                      <!-- 取消时间 -->
                      <el-option :label="$t('newOrder.CancellationTime')" :value="3" />
                    </el-select>
                  </template>
                  <el-date-picker
                    v-model="queryForm.params.invoiceIssueTime"
                    type="datetimerange"
                    range-separator="-"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    :start-placeholder="$t('GlobalSetObj.startDate')"
                    :end-placeholder="$t('GlobalSetObj.endDate')"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="'MDF-e' + $t('collectionCenter.stateZT')">
                  <el-select v-model="queryForm.params.statusList" style="width: 100%;" multiple>
                    <el-option key="1" :label="$t('mdfeTranslate.Authorized')" :value="1" /><!--已授权-->
                    <el-option key="2" :label="$t('collectionCenter.cancelled')" :value="2" /><!--已取消-->
                    <el-option key="3" :label="$t('mdfeTranslate.Closed')" :value="3" /><!--已关闭-->
                  </el-select>
                </el-form-item>
              </el-col>
              <!--车辆运营模式-->
              <el-col :span="7">
                <el-form-item :label="$t('mdfeTranslate.VehicleOperationMode')">
                  <el-select v-model="queryForm.params.vehicleOperationMode" style="width: 100%;">
                    <el-option key="0" :label="$t('basicData.all')" :value="null" />
                    <el-option key="1" :label="$t('basicData.SelfOperated')" :value="0" /><!--自营-->
                    <el-option key="2" :label="$t('basicData.thirdParty')" :value="1" /><!--第三方-->
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <div>
              <!--查询-->
              <el-button
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="enterGetSearch"
              >{{ $t('basicData.Search') }}
              </el-button>
              <!--重置-->
              <el-button
                icon="el-icon-refresh"
                size="mini"
                @click="resetData"
              >{{ $t('basicData.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div class="mb10">
        <!--批量导出-->
        <el-button
          v-permit:remove="'btn:invoiceCenter:mdfe-bulkExport'"
          size="small"
          type="primary"
          @click="bulkExportMdfe"
        >
          {{ $t('collectionCenter.BulkExport') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:invoiceCenter:mdfe-addMDFE'"
          size="small"
          type="primary"
          @click="addMDFE"
        >
          {{ $t('collectionCenter.generate') + 'MDFE' }}
        </el-button>
        <!-- 强制关闭-->
        <el-button
          v-permit:remove="'btn:invoiceCenter:mdfe-ForceClose'"
          size="small"
          type="danger"
          @click="forceClose"
        >
          {{ $t('mdfeTranslate.ForceClose') }}
        </el-button>
        <!-- 异常mdfe-->
        <el-button
          v-permit:remove="'btn:invoiceCenter:mdfe-AbnormalMdfe'"
          size="small"
          type="primary"
          @click="showAbnormalWindow"
        >
          {{ $t('mdfeTranslate.AbnormalMdfe') }}
        </el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')" align="center" type="index"
          width="80"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :align="item.center"
          :label="item.label"
          :min-width="item.minWidth"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'status'">
              <!--'已生成'-->
              <el-tag v-if="scope.row.status === 1" size="mini" type="success">{{ $t('mdfeTranslate.Authorized') }}</el-tag>
              <!--已取消-->
              <el-tag v-else-if="scope.row.status === 2" size="mini" type="info">{{ $t('GlobalSetObj.Canceled') }}</el-tag>
              <!--已关闭-->
              <el-tag v-else-if="scope.row.status === 3" size="mini" type="danger">{{ $t('mdfeTranslate.Closed') }}</el-tag>
            </div>
            <div v-else-if="item.prop === 'vehiclePlate'">
              <div v-for="(item, ind) in scope.row.transportInfo.vehiclePlate" :key="ind">
                {{ item }}
              </div>
            </div>
            <div v-else-if="item.prop === 'repeatPackage'">
              <div v-for="(item, ind) in scope.row.transportInfo.repeatPackage" :key="ind">
                {{ item }}
              </div>
            </div>
            <div v-else>
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('GlobalSetObj.operate')"
          align="center"
          fixed="right"
          width="100"
        >
          <template slot-scope="scope">
            <el-popover
              placement="bottom"
              trigger="click"
            >
              <el-button slot="reference" size="mini" type="text"><i class="el-icon-more" style="font-size: 26px" /></el-button>
              <div
                v-if="scope.row.status === 1"
                v-permit:remove="'btn:invoiceCenter:mdfe-lockMDFE'"
                style="margin: 5px"
              >
                <!--关闭-->
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top-start"
                >
                  <template slot="content">
                    <div>
                      <i class="iconfont icon-a-ziyuan106" style="color: #1d90ff;font-size: 12px!important;margin-right: 5px;" />
                      {{ $t('mdfeTranslate.EncerrarMdfeTips') }}
                    </div>
                  </template>
                  <el-button
                    size="mini" type="primary"
                    @click="closeMDFE(scope.row)"
                  >{{ $t('mdfeTranslate.LockMDFE') }}</el-button>
                </el-tooltip>
              </div>
              <div
                v-if="scope.row.status === 1"
                v-permit:remove="'btn:invoiceCenter:mdfe-clearMDFE'"
                style="margin: 5px"
              >
                <!--取消-->
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top-start"
                >
                  <template slot="content">
                    <div>
                      <i class="iconfont icon-a-ziyuan40" style="color: #bd2c00;font-size: 12px!important;margin-right: 5px;" />
                      {{ $t('mdfeTranslate.CancelMdfeTips') }}
                    </div>
                  </template>
                  <el-button
                    size="mini" type="primary"
                    @click="clearMDFE(scope.row)"
                  >{{ $t('mdfeTranslate.CancelMDFE') }}</el-button>
                </el-tooltip>
              </div>
              <div
                v-if="scope.row.status === 1 || scope.row.status === 3"
                v-permit:remove="'btn:invoiceCenter:mdfe-viewMDFEPDF'"
                style="margin: 5px"
              >
                <!--查看PDF-->
                <el-button
                  size="mini"
                  type="primary"
                  @click="viewMDFEPDF(scope.row)"
                >{{ $t('mdfeTranslate.ViewPDF') }}</el-button>
              </div>
              <div
                v-if="scope.row.status === 1"
                v-permit:remove="'btn:invoiceCenter:mdfe-downloadCtePDF'"
                style="margin: 5px"
              >
                <!--批量生成CTE PDF-->
                <el-button
                  size="mini" type="primary"
                  @click="downloadCtePDF(scope.row)"
                >{{ $t('mdfeTranslate.BatchCTEPDF') }}</el-button>
              </div>
              <div
                v-permit:remove="'btn:invoiceCenter:mdfe-viewDriver'"
                style="margin: 5px"
              >
                <!--查看司机-->
                <el-button
                  size="mini" type="primary"
                  @click="viewDriver(scope.row)"
                >{{ $t('mdfeTranslate.ViewDriver') }}</el-button>
              </div>
              <div
                v-permit:remove="'btn:invoiceCenter:mdfe-downloadXlsx'"
                style="margin: 5px"
              >
                <!--下载xlsx-->
                <el-button
                  size="mini" type="primary"
                  @click="downloadXlsx(scope.row)"
                >{{ $t('mdfeTranslate.DownloadXlsx') }}</el-button>
              </div>
              <div
                v-permit:remove="'btn:invoiceCenter:mdfe-downloadXml'"
                style="margin: 5px"
              >
                <!--下载xml-->
                <el-button
                  size="mini" type="primary"
                  @click="downloadXml(scope.row)"
                >{{ $t('mdfeTranslate.DownloadXml') }}</el-button>
              </div>
              <div style="margin: 5px">
                <!--查看操作日志-->
                <el-button
                  size="mini" type="primary"
                  @click="openOperationalLogs(scope.row)"
                >{{ $t('operationCenter.OperationalLogs') }}</el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="queryForm.total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
    <!-- 添加MDFE-->
    <addMdfe
      :show-add-m-d-f-e-window="showAddMDFEWindow"
      :sender-state-list="senderStateList"
      @closeWindow="updateData"
    />
    <!--查看司机-->
    <el-dialog
      :title="$t('mdfeTranslate.ViewDriver')"
      :visible.sync="showViewDriverWindow"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div>
        <div v-for="(item, index) in driverInformation" :key="index" style="border: 1px solid #ccc;border-radius: 5px;padding: 10px;margin-bottom: 10px;">
          <div>
            <i class="el-icon-user" style="margin-right: 3px;" />
            <span style="color: #000;font-weight: bold">{{ $t('ChannelManage.name') }}：</span>
            {{ item.name }}
          </div>
          <div>
            <i class="iconfont icon-liebiao" style="margin-right: 3px;" />
            <span style="color: #000;font-weight: bold">CPF：</span>
            {{ item.cpf }}
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showViewDriverWindow = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
    <!--查看pdf-->
    <el-dialog
      :title="$t('mdfeTranslate.ViewPDF')"
      :visible.sync="showViewPDFWindow"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div>
        <pdfHtml
          v-if="showViewPDFWindow"
          :key="viewPDFWindowKey"
          :row-m-d-f-e-data="rowMDFEData"
          :cte-data="cteData"
          :pdf-data="pdfData"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showViewPDFWindow = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
    <!--下载xlsx-->
    <el-dialog
      :title="$t('mdfeTranslate.DownloadXlsx')"
      :visible.sync="showDownloadXlsx"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div v-if="showDownloadXlsx">
        <downloadXlsx
          ref="downloadXlsxRef"
          :key="downloadXlsxKey"
          :cte-data="cteData"
          :row-m-d-f-e-data="rowMDFEData"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" type="primary"
          @click="confirmDownloadXlsx"
        >{{ $t('GlobalSetObj.Download') }}</el-button>
        <el-button size="small" @click="showDownloadXlsx = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
    <!--下载XML-->
    <el-dialog
      :title="$t('mdfeTranslate.DownloadXml')"
      :visible.sync="showDownloadXML"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div style="border-radius: 5px;border: 1px solid #ccc;padding: 10px;width: 100%;height: 500px;overflow:auto;">
        <pre>{{ rowMDFEData.xmlString }}</pre>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" type="primary"
          @click="confirmDownloadXML"
        >{{ $t('GlobalSetObj.Download') }}</el-button>
        <el-button size="small" @click="showDownloadXML = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
    <!--下载ctePDF-->
    <el-dialog
      :title="$t('mdfeTranslate.BatchCTEPDF')"
      :visible.sync="showDownloadCtePDF"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div style="border-radius: 5px;">
        <div
          ref="virtualContainer"
          class="virtual-scroll-container-pdf"
          @scroll="handleScrollPDF"
        >
          <div class="virtual-scroll-placeholder-pdf" :style="{ height: totalHeightPDF + 'px' }">
            <div
              class="virtual-scroll-content-pdf"
              :style="{ transform: `translateY(${offsetYPDF}px)` }"
            >
              <div
                v-for="(item, index) in visibleItemsPDF"
                :key="index"
                style="padding: 3px 10px;border: 1px solid #ddd;border-radius: 3px;margin: 5px;"
              >
                {{ item.invoiceKey }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" type="primary"
          :disabled="cteData.length === 0"
          @click="confirmDownloadCtePDF"
        >{{ $t('GlobalSetObj.Download') }}</el-button>
        <el-button size="small" @click="showDownloadCtePDF = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('mdfeTranslate.BatchCTEPDF')"
      :visible.sync="showDownloadCteXML"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div>
        <ctePDF :key="downloadCteXMLKey" :row-m-d-f-e-data="rowMDFEData" :cte-data="cteData" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showDownloadCteXML = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
    <!--强制关闭-->
    <el-dialog
      :title="$t('mdfeTranslate.ForceClose')"
      :visible.sync="showForceCloseWindow"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div>
        <forceClose
          ref="forceCloseRef"
          :key="forceCloseKey"
          @forceCloseSuccess="forceCloseSuccess"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" type="primary"
          @click="confirmForceClose"
        >{{ $t('collectionCenter.confirm') }}</el-button>
        <el-button size="small" @click="showForceCloseWindow = false">{{ $t('collectionCenter.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--查看操作日志-->
    <el-drawer
      :title="$t('operationCenter.OperationalLogs')"
      :visible.sync="showOperationalLogs"
      direction="rtl"
      size="80vw"
    >
      <operational-log :key="operationalLogKey" :log-key="logKey" />
    </el-drawer>
    <!--异常MDFE-->
    <el-dialog
      :title="$t('mdfeTranslate.AbnormalMdfeProcessing')"
      :visible.sync="showAbnormalMdfe"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <abnormalMdfe :key="abnormalKey" @updateTable="updateTable" />
    </el-dialog>
    <!--关闭提示-->
    <el-dialog
      :visible.sync="showCloseMdfeWindow"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="3%"
    >
      <template slot="title">
        <div class="closeTitle">
          <i class="el-icon-question" />
          <!--关闭 MDF-e (结束行程)-->
          <span class="titleCont">{{ $t('mdfeTranslate.CloseMDFeEndTheTrip') }}</span>
        </div>
      </template>
      <div>
        <close-mdfe-tips />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showCloseMdfeWindow = false">{{ $t('mdfeTranslate.Cancel') }}</el-button>
        <el-button type="primary" icon="el-icon-check" @click="confirmCloseMDFe">
          {{ $t('mdfeTranslate.Confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!--取消提示-->
    <el-dialog
      :visible.sync="showCancelMdfeWindow"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="3%"
    >
      <template slot="title">
        <div class="closeTitle">
          <i class="el-icon-warning" />
          <!--取消MDF-e（整单作废）-->
          <span class="titleCont">{{ $t('mdfeTranslate.CancelMDFe') }}</span>
        </div>
      </template>
      <div>
        <cancel-mdfe-tips
          ref="cancelMdfeDataRef"
          :key="showCancelMdfeWindow"
          :row-m-d-f-e-data="rowMDFEData"
          @cancelMdfeSuccess="cancelMdfeSuccess"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showCancelMdfeWindow = false">{{ $t('mdfeTranslate.Cancel') }}</el-button>
        <el-button
          type="primary" icon="el-icon-close" style="background: #d52526;border: 0"
          @click="confirmCancelMDFe"
        >
          {{ $t('mdfeTranslate.Confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  closeMdfeApi,
  getCteByMdfe,
  getDriverByMdfe,
  getMDfePage,
  parseMdfeXml,
  getMidProvince,
  downloadXmlApi,
  exportMdfeBatch
} from '@/api/invoiceCenter';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import pdfHtml from './cmp/newPdf.vue';
import addMdfe from './cmp/addMdfe.vue';
import ctePDF from './cmp/ctePDFNew.vue';
import abnormalMdfe from './cmp/abnormalMdfe.vue';
import operationalLog from './cmp/operationalLog.vue';
import { formatNumber } from '@/utils/tools';
import { goResourceTaskList } from '@/utils/goExportList';
import forceClose from './cmp/forceClose.vue';
import downloadXlsx from './cmp/downloadXlsx.vue';
import CloseMdfeTips from './cmp/closeMdfeTips.vue';
import CancelMdfeTips from './cmp/cancelMdfeTips.vue';
const dayjs = require('dayjs');
const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
export default {
  name: 'Mdfe',
  components: {
    CancelMdfeTips,
    CloseMdfeTips,
    downloadXlsx,
    pdfHtml,
    addMdfe,
    ctePDF,
    operationalLog,
    abnormalMdfe,
    forceClose
  },
  mixins: [estimateTableHeight],
  data() {
    return {
      licensePlateNumber: '',
      mdfeKeyStr: '',
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        params: {
          // documentNumber: null,
          protocolNumber: null,
          mdfeKeys: [],
          originState: null,
          destinationState: null,
          timeType: 1,
          invoiceIssueTime: [startTime, endTime],
          vehicleNumberList: [],
          statusList: [],
          vehicleOperationMode: null
        }
      },
      pickerMinDate: '',
      pickerRange: 180 * 24 * 60 * 60 * 1000, // 可选择日期范围 为15天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      tableData: [],
      senderStateList: [],
      tableHeaderList: [
        // MDFE编号
        { id: 1, label: this.$t('mdfeTranslate.MDFEEncoding'), prop: 'documentNumber', minWidth: 140, center: 'center' }, // mdfe编号
        // MDFE秘钥
        { id: 2, label: this.$t('mdfeTranslate.MDFEKey'), prop: 'mdfeKey', minWidth: 400, center: 'center' }, // mdfe秘钥
        // cte数量
        { id: 11, label: this.$t('mdfeTranslate.cteCount'), prop: 'cteCount', minWidth: 120, center: 'center' },
        // 车牌号
        { id: 10, label: this.$t('seller.licensePlateNumber'), prop: 'vehiclePlate', minWidth: 140, center: 'center' }, // 车牌号
        // 司机姓名
        { id: 12, label: this.$t('collectionCenter.driverName'), prop: 'driverNames', minWidth: 140, center: 'center' }, // 司机姓名
        // 重复运单号
        { id: 9, label: this.$t('mdfeTranslate.RepeatedWaybillNumber'), prop: 'repeatPackage', minWidth: 200, center: 'center' }, // 重复运单号
        // 起点
        { id: 3, label: this.$t('mdfeTranslate.startingPoint'), prop: 'originCity', minWidth: 140, center: 'center' }, // 起点
        // 目的地
        { id: 4, label: this.$t('mdfeTranslate.destination'), prop: 'destinationCity', minWidth: 140, center: 'center' }, // 目的地
        // 协议编号
        { id: 5, label: this.$t('mdfeTranslate.AgreementNumber'), prop: 'protocolNumber', minWidth: 140, center: 'center' }, // 协议编号
        // 状态
        { id: 6, label: this.$t('GlobalSetObj.status'), prop: 'status', minWidth: 140, center: 'center' }, // 状态
        // 创建人
        { id: 7, label: this.$t('GlobalSetObj.CreatePeople'), prop: 'createUserName', minWidth: 160, center: 'center' }, // 创建人
        // 创建时间
        { id: 8, label: this.$t('GlobalSetObj.CreationTime'), prop: 'createTime', minWidth: 180, center: 'center' } // 创建时间
      ],
      showAddMDFEWindow: false,
      rowMDFEData: {},
      showViewDriverWindow: false,
      showViewPDFWindow: false,
      cteData: [],
      driverInformation: [],
      showDownloadXlsx: false,
      showDownloadXML: false,
      pdfData: {
        totalFrete: 0,
        totalIcms: 0
      },
      showDownloadCtePDF: false,
      showDownloadCteXML: false,
      viewPDFWindowKey: new Date().getTime(),
      downloadCteXMLKey: new Date().getTime(),
      showForceCloseWindow: false,
      itemHeightPDF: 30, // 每个item的预估高度
      containerHeightPDF: 400, // 容器高度
      visibleItemCountPDF: 12, // 可见的item数量
      visibleStartIndexPDF: 0, // 可见区域的起始索引
      offsetYPDF: 0, // 偏移量
      showOperationalLogs: false,
      logKey: null,
      operationalLogKey: new Date().getTime(),
      formatNumber,
      showAbnormalMdfe: false,
      abnormalKey: new Date().getTime(),
      showCloseMdfeWindow: false,
      showCancelMdfeWindow: false,
      forceCloseKey: new Date().getTime(),
      downloadXlsxKey: new Date().getTime()
    };
  },
  computed: {
    // 计算总高度
    totalHeightPDF() {
      return this.cteData.length * this.itemHeightPDF;
    },

    // 计算可见的items
    visibleItemsPDF() {
      const start = this.visibleStartIndexPDF;
      const end = Math.min(start + this.visibleItemCountPDF, this.cteData.length);
      return this.cteData.slice(start, end);
    }
  },
  mounted() {
    // 初始化容器高度
    this.updateContainerHeightPDF();
  },
  created() {
    this.getAddress();
    this.getTableDataList();
  },
  methods: {
    // 关闭强制关闭窗口
    forceCloseSuccess() {
      this.showForceCloseWindow = false;
      this.getTableDataList();
    },
    // 批量导出mdfe
    bulkExportMdfe() {
      const params = this.getParams();
      exportMdfeBatch(params).then(res => {
        goResourceTaskList();
      });
    },
    // 异常mdfe更新列表数据
    updateTable() {
      this.getTableDataList();
      this.showAbnormalMdfe = false;
    },
    // 打开异常mdfe弹窗
    showAbnormalWindow() {
      this.showAbnormalMdfe = true;
      this.abnormalKey = new Date().getTime();
    },
    // 打开操作日志弹窗
    openOperationalLogs(row) {
      this.logKey = row;
      this.showOperationalLogs = true;
      this.operationalLogKey = new Date().getTime();
    },
    // 更新容器高度
    updateContainerHeightPDF() {
      if (this.$refs.virtualContainer) {
        this.containerHeightPDF = this.$refs.virtualContainer.clientHeight || 600;
        this.visibleItemCountPDF = Math.ceil(this.containerHeightPDF / this.itemHeight) + 2; // 多渲染几个item以确保滚动顺畅
      }
    },
    // 处理滚动事件
    handleScrollPDF(event) {
      const scrollTop = event.target.scrollTop;
      const newStartIndex = Math.floor(scrollTop / this.itemHeightPDF);

      // 只有当起始索引发生变化时才更新
      if (newStartIndex !== this.visibleStartIndexPDF) {
        this.visibleStartIndexPDF = newStartIndex;
        this.offsetYPDF = newStartIndex * this.itemHeightPDF;
      }
    },
    // 确定强制关闭
    confirmForceClose() {
      this.$refs.forceCloseRef.forceCloseSubmit();
    },
    // 打开强制关闭
    forceClose() {
      this.showForceCloseWindow = true;
      this.forceCloseKey = new Date().getTime();
    },
    // 确定下载ctePdf
    confirmDownloadCtePDF() {
      this.showDownloadCteXML = true;
      this.downloadCteXMLKey = new Date().getTime();
    },
    // 打开下载ctePdf弹窗
    downloadCtePDF(row) {
      const param = {
        mdfeKey: row.mdfeKey
      };
      getCteByMdfe(param).then(res => {
        if (res.code === 200) {
          res.data.map(item => {
            if (item.cteCreateDate) {
              item.cteCreateDate = this.removeTimezone(item.cteCreateDate);
            }
          });
          this.rowMDFEData = row;
          this.cteData = res.data;
          this.showDownloadCtePDF = true;
        }
      });
    },
    // 关闭生成mdfe弹窗，更新数据
    updateData(type = false) {
      if (type) {
        this.getTableDataList();
      }
      this.showAddMDFEWindow = false;
    },
    // 确定下载xml
    confirmDownloadXML() {
      const xmlContent = this.rowMDFEData.mdfeXml;
      const blob = new Blob([xmlContent], { type: 'text/xml' }); // 使用 text/xml 类型
      const filename = `MDFE_${this.rowMDFEData.mdfeKey}.xml`; // 使用 .xml 后缀

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    // 下载XML
    downloadXml(row) {
      // const formatXml = (xmlString) => {
      //   const parser = new DOMParser();
      //   const xmlDoc = parser.parseFromString(xmlString, 'application/xml');
      //   // 格式化节点缩进函数
      //   const formatNode = (node, indent = 0) => {
      //     const indentStr = '  '.repeat(indent);
      //     let result = '';
      //     if (node.nodeType === Node.ELEMENT_NODE) {
      //       const children = Array.from(node.childNodes);
      //       const hasTextOnly = children.every(
      //         (n) => n.nodeType === Node.TEXT_NODE && !n.textContent.trim()
      //       );
      //       result += `${indentStr}<${node.tagName}`;
      //       // 添加属性
      //       if (node.attributes.length > 0) {
      //         for (const attr of node.attributes) {
      //           result += ` ${attr.name}="${attr.value}"`;
      //         }
      //       }
      //       if (children.length === 0) {
      //         result += ` />\n`;
      //       } else if (hasTextOnly) {
      //         result += `>${node.textContent}</${node.tagName}>\n`;
      //       } else {
      //         result += `>\n`;
      //         for (const child of children) {
      //           result += formatNode(child, indent + 1);
      //         }
      //         result += `${indentStr}</${node.tagName}>\n`;
      //       }
      //     } else if (node.nodeType === Node.TEXT_NODE) {
      //       const text = node.textContent.trim();
      //       if (text) {
      //         result += `${indentStr}${text}\n`;
      //       }
      //     } else if (node.nodeType === Node.COMMENT_NODE) {
      //       result += `${indentStr}<!--${node.textContent}-->\n`;
      //     }
      //     return result;
      //   };
      //   // 提取原始 XML 声明
      //   const xmlDeclarationMatch = xmlString.match(/<\?xml.*?\?>/);
      //   const xmlDeclaration = xmlDeclarationMatch ? xmlDeclarationMatch[0] + '\n' : '<?xml version="1.0" encoding="UTF-8"?>\n';
      //   const formattedContent = formatNode(xmlDoc.documentElement);
      //   return xmlDeclaration + formattedContent;
      // };
      downloadXmlApi(row.mdfeKey).then(res => {
        if (res.code === 200) {
          const link = document.createElement('a');
          link.href = res.data;
          link.download = `MDFE_${row.mdfeKey}.xml`;
          link.click();
        }
        // this.rowMDFEData = row;
        // if (res.data) {
        //   this.rowMDFEData.mdfeXml = res.data;
        //   this.rowMDFEData.xmlString = formatXml(row.mdfeXml);
        //   this.showDownloadXML = true;
        // } else {
        //   this.$message.error(this.$t('collectionCenter.nullMsg'));
        // }
      });
    },
    // 确定下载xlsx
    confirmDownloadXlsx() {
      const that = this;
      if (that.cteData.length === 0) {
        this.$message.error(this.$t('collectionCenter.nullMsg'));
        return;
      }
      this.$refs.downloadXlsxRef.downloadXlsxList();
    },
    // 下载xlsx
    downloadXlsx(row) {
      const param = {
        mdfeKey: row.mdfeKey
      };
      getCteByMdfe(param).then(res => {
        if (res.code === 200) {
          this.rowMDFEData = row;
          res.data.map((item, index) => {
            item.keyPropId = index + 1;
          });
          this.cteData = res.data || [];
          this.$nextTick(() => {
            this.showDownloadXlsx = true;
            this.downloadXlsxKey = new Date().getTime();
            if (this.$refs.virtualScroll) {
              this.$refs.virtualScroll.forceUpdate();
            }
          });
        }
      });
    },
    // 获取cte列表
    apiRequest1(row) {
      return new Promise((resolve, reject) => {
        const param = {
          mdfeKey: row.mdfeKey
        };
        getCteByMdfe(param).then(res => {
          if (res.code === 200) {
            res.data.map(item => {
              this.pdfData.totalFrete += Number(item.frete);
              this.pdfData.totalIcms += Number(item.icmsAmount);
            });
            this.cteData = res.data;
            resolve(res.data);
          }
        });
      });
    },
    // 日期转换
    removeTimezone(dateString) {
      console.log(dateString, '====dateString');
      if (dateString) {
        const parts = dateString.split('-');
        const date = parts.slice(0, -1).join('-');
        const dateFormat = date.replace(/-/g, '/');
        return dateFormat.replace(/T/g, ' ');
      } else {
        return '';
      }
    },
    // 获取pdf基础信息
    apiRequest2(row) {
      return new Promise((resolve, reject) => {
        const param = {
          mdfeKey: row.mdfeKey
        };
        parseMdfeXml(param).then(res => {
          if (res.code === 200) {
            if (res.data.mdfeCreatDate) {
              res.data.mdfeCreatDate = this.removeTimezone(res.data.mdfeCreatDate);
            }
            if (res.data.mdfeStartDate) {
              res.data.mdfeStartDate = this.removeTimezone(res.data.mdfeStartDate);
            }
            this.rowMDFEData = res.data;
            resolve(res.data);
          }
        });
      });
    },
    // 查看PDF
    viewMDFEPDF(row) {
      this.pdfData = {
        totalFrete: 0,
        totalIcms: 0
      };
      Promise.all([this.apiRequest1(row), this.apiRequest2(row)])
        .then(() => {
          this.showViewPDFWindow = true;
          this.viewPDFWindowKey = new Date().getTime();
        })
        .catch(error => {
          // 任意一个接口失败都会触发 catch
          console.error('其中一个接口出错:', error);
        });
    },
    // 查看司机
    viewDriver(row) {
      this.rowMDFEData = row;
      getDriverByMdfe({ mdfeKey: row.mdfeKey }).then(res => {
        if (res.code === 200) {
          this.driverInformation = res.data;
          this.showViewDriverWindow = true;
        }
      });
    },
    // 关闭MDFE
    closeMDFE(row) {
      this.rowMDFEData = row;
      this.showCloseMdfeWindow = true;
    },
    // 确定关闭mdfe
    confirmCloseMDFe() {
      const param = {
        mdfeKey: this.rowMDFEData.mdfeKey
      };
      closeMdfeApi(param).then(res => {
        if (res.code === 200) {
          if (res.data.success) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // 操作成功
            this.showCloseMdfeWindow = false;
            this.getTableDataList();
          } else {
            this.$message.error(res.data.failureReason || this.$t('mdfeTranslate.OperationFailed')); // 操作失败
          }
        }
      });
    },
    // 取消MDFE
    clearMDFE(row) {
      this.rowMDFEData = row;
      this.showCancelMdfeWindow = true;
    },
    // 确定取消
    confirmCancelMDFe() {
      this.$refs.cancelMdfeDataRef.confirmCancelMdfe();
    },
    // 关闭取消mdfe窗口
    cancelMdfeSuccess() {
      this.getTableDataList();
      this.showCancelMdfeWindow = false;
    },
    // 添加addMDFE
    addMDFE() {
      this.showAddMDFEWindow = true;
    },
    // 搜索
    enterGetSearch() {
      this.queryForm.pageNumber = 1;
      this.getTableDataList();
    },
    // 重置
    resetData() {
      this.queryForm.pageNumber = 1;
      this.licensePlateNumber = '';
      this.mdfeKeyStr = '';
      this.queryForm.params = {
        // documentNumber: null,
        protocolNumber: null,
        mdfeKeys: [],
        originState: null,
        destinationState: null,
        timeType: 1,
        invoiceIssueTime: [startTime, endTime],
        statusList: [],
        vehicleNumberList: [],
        vehicleOperationMode: null
        // cteKey: ''
      };
      this.getTableDataList();
    },
    // 参数整理
    getParams() {
      const obj = {
        // documentNumber: this.queryForm.params.documentNumber,
        protocolNumber: this.queryForm.params.protocolNumber,
        mdfeKeys: [],
        originState: this.queryForm.params.originState,
        destinationState: this.queryForm.params.destinationState,
        timeType: this.queryForm.params.timeType,
        startTime: '',
        endTime: '',
        statusList: this.queryForm.params.statusList,
        vehicleNumberList: [],
        vehicleOperationMode: this.queryForm.params.vehicleOperationMode
        // cteKey: this.queryForm.params.cteKey
      };
      const { invoiceIssueTime } = this.queryForm.params;
      if (Array.isArray(invoiceIssueTime) && invoiceIssueTime.length === 2) {
        obj.startTime = invoiceIssueTime[0];
        obj.endTime = invoiceIssueTime[1];
      }
      if (this.licensePlateNumber) {
        obj.vehicleNumberList = this.licensePlateNumber.split(/\r?\n/).map(item => item.replace(/\s+/g, '')).filter(item => Boolean(item));
      }
      if (this.mdfeKeyStr) {
        obj.mdfeKeys = this.mdfeKeyStr.split(/\r?\n/).map(item => item.replace(/\s+/g, '')).filter(item => Boolean(item));
      }
      return obj;
    },
    // 获取列表
    getTableDataList() {
      const params = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: this.getParams()
      };
      if (!params.params.startTime && !params.params.endTime) {
        if (params.params.mdfeKeys.length === 0 && !params.params.protocolNumber) {
          this.$message.error(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      if (params.params.vehicleNumberList.length > 10) {
        this.$message.error(this.$t('mdfeTranslate.MostlyQuery10Plates'));
        return;
      }
      if (params.params.mdfeKeys.length > 2000) {
        this.$message.error(this.$t('mdfeTranslate.SingleMostQuery2000MDFEKey'));
        return;
      }
      getMDfePage(params).then(res => {
        if (res.code === 200) {
          res.data.records.map(item => {
            item.transportInfo = JSON.parse(item.transportInfo);
          });
          this.tableData = res.data.records;
          this.queryForm.total = res.data.total;
        }
      });
    },
    // 获取起点和目的地选项
    getAddress() {
      getMidProvince().then((res) => {
        if (res.code === 200) {
          this.senderStateList = res.data;
        }
      });
    },
    // 每页显示数量改变时触发
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableDataList();
    },
    // 当前页码改变时触发
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableDataList();
    }
  }
};
</script>

<style>
@import "./index.css";
</style>
